import { Typography } from "@kitbird/core";
import { EmptyStateContainer } from "../BusinessTrx.styled";
import { ReactComponent as EmptyIllustration } from "../../../../assets/images/empty_table.svg";

const EmptyState = () => (
  <EmptyStateContainer>
    <EmptyIllustration />
    <Typography level={4} fontWeight="medium">Maaf, Data yang anda cari belum tersedia</Typography>
  </EmptyStateContainer>
);

export default EmptyState;
